import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

// Shared card for Sign In and Create Account. It stays mounted while switching
// tabs, so only the content swaps and the card height animates smoothly.
export default function AuthCardShell() {
  const location = useLocation();
  const innerRef = useRef(null);
  const [height, setHeight] = useState("auto");

  useEffect(() => {
    const el = innerRef.current;
    const ro = new ResizeObserver(() => setHeight(el.offsetHeight));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden">
      <div className="absolute top-[calc(50%-18rem)] left-[calc(50%+8rem)] w-48 h-48 bg-pink-200 rounded-full opacity-50 blur-3xl pointer-events-none animate-drift" />
      <div className="absolute top-[calc(50%+8rem)] left-[calc(50%-20rem)] w-40 h-40 bg-pink-200 rounded-full opacity-40 blur-3xl pointer-events-none animate-drift [animation-delay:-4s] [animation-direction:reverse]" />

      <div
        className="w-full max-w-md bg-white rounded-3xl shadow-lg border border-gray-200 relative z-10 overflow-hidden transition-[height] duration-500 ease-in-out animate-fade-up"
        style={{ height }}
      >
        <div ref={innerRef} className="p-8 min-h-[740px] flex flex-col">
          <div className="auth-logo flex justify-center mb-5">
            <img
              src="https://media.base44.com/images/public/6958216a4cd06732f9f425e2/622d62138_E15D7C0A-6AAD-4394-88FA-3041401B85AB.png"
              alt="Peony Gifts & Kitchen"
              className="w-36 animate-spin-in"
            />
          </div>
          <div key={location.pathname} className="animate-fade-up flex-1 flex flex-col">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}